import params from "../../../setup/config/params";
import { IMAGE_SOURCE_PATH } from "../../../setup/config/env";
import Analytics from "../index";
import { defaultImage } from "../../common/Sidebar";

export function getImageSource(image = defaultImage) {
    return `${IMAGE_SOURCE_PATH}${image}`;
}

const routes = {
    analytics: {
        path: `/analytics`,
        component: Analytics,
        auth: true,
        role: params.user.roles.admin.key,
        module:"store",
        subModule:"analytics",
        action:"canView"
    }
};
export default routes;